import InfoPage from '@/components/InfoPage';
import { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border-b border-gray-200 py-4">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex justify-between items-center w-full text-left"
      >
        <h3 className="font-semibold text-lg">{question}</h3>
        {isOpen ? <ChevronUp className="w-5 h-5" /> : <ChevronDown className="w-5 h-5" />}
      </button>
      {isOpen && (
        <p className="mt-3 text-gray-600">{answer}</p>
      )}
    </div>
  );
};

const FAQ = () => {
  const faqs = [
    {
      question: "O ParkingSpot é realmente gratuito?",
      answer: "Sim! O ParkingSpot é 100% gratuito para motoristas e proprietários de estacionamentos. Nunca cobraremos taxas de uso da plataforma."
    },
    {
      question: "Como faço para cadastrar meu estacionamento?",
      answer: "Basta criar uma conta, fazer login e acessar o Dashboard do Proprietário. Lá você pode adicionar todos os detalhes do seu estacionamento, incluindo localização, preços e número de vagas."
    },
    {
      question: "As informações de vagas são atualizadas em tempo real?",
      answer: "Sim! Os proprietários podem atualizar o número de vagas disponíveis a qualquer momento, e essas informações são exibidas imediatamente no mapa para os usuários."
    },
    {
      question: "Preciso de uma conta para buscar estacionamentos?",
      answer: "Não! Você pode buscar e visualizar estacionamentos no mapa sem criar uma conta. A conta é necessária apenas para proprietários que desejam cadastrar seus estacionamentos."
    },
    {
      question: "Como são definidos os preços?",
      answer: "Os preços são definidos pelos próprios proprietários dos estacionamentos. O ParkingSpot não interfere na precificação e não cobra comissões."
    },
    {
      question: "O que significam as cores no mapa?",
      answer: "Azul (#302681) indica estacionamentos cobertos (indoor), Verde (#009440) indica estacionamentos descobertos (outdoor), e Amarelo (#FFCB00) indica estacionamentos mistos."
    },
    {
      question: "Posso fazer reservas através do ParkingSpot?",
      answer: "Atualmente o ParkingSpot funciona como uma plataforma de informações em tempo real. Não fazemos reservas, mas mostramos a disponibilidade atual de vagas."
    },
    {
      question: "Como posso reportar informações incorretas?",
      answer: "Entre em contato através da nossa Central de Ajuda ou envie um email para contato@parkingspot.com.br com detalhes sobre a informação incorreta."
    },
    {
      question: "O aplicativo funciona em todo o Brasil?",
      answer: "Sim! O ParkingSpot está disponível em todo território nacional. Estamos constantemente expandindo nossa rede de estacionamentos cadastrados."
    },
    {
      question: "Meus dados estão seguros?",
      answer: "Sim! Utilizamos Firebase Authentication e seguimos todas as diretrizes da LGPD para proteger seus dados. Leia nossa Política de Privacidade para mais detalhes."
    }
  ];

  return (
    <InfoPage title="Perguntas Frequentes (FAQ)">
      <div className="space-y-2">
        {faqs.map((faq, index) => (
          <FAQItem key={index} question={faq.question} answer={faq.answer} />
        ))}
      </div>
      
      <div className="mt-8 bg-blue-50 p-6 rounded-lg">
        <h3 className="font-semibold mb-2">Não encontrou sua resposta?</h3>
        <p className="text-gray-700">
          Entre em contato conosco através da{' '}
          <a href="/ajuda" className="text-[#302681] hover:underline font-semibold">
            Central de Ajuda
          </a>
        </p>
      </div>
    </InfoPage>
  );
};

export default FAQ;
